import React from "react";
import { Form, Button, Row, Col } from "react-bootstrap";

function FileManager({ exportData, importData }) {
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      importData(file); // Appeler la fonction d'importation avec le fichier sélectionné
    }
  };

  return (
    <Form className='mb-2'>
      <Row className='g-2'>        
        <Col xs={6} sm={6}>
          <Form.Group className='mb-0'>
            <label htmlFor='file-import' className='btn btn-secondary btn-sm w-100'>
              Importer
            </label>
            <Form.Control
              id='file-import'
              className='form-control-sm'
              type='file'
              accept='.json'
              onChange={handleFileChange}
              style={{ display: 'none' }} // Cache le champ de fichier
            />
          </Form.Group>
        </Col>
        <Col xs={6} sm={6}>
          <Button
            variant='secondary'
            className='btn-sm w-100'
            onClick={exportData}>
            Exporter
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

export default FileManager;
